import {Mapper} from '@s-ui/domain'

export class FromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper extends Mapper {
  constructor({config, breadcrumbValueObject}) {
    super()

    this._config = config
    this._valueObject = breadcrumbValueObject
  }

  map = ({detailParams, urlsResponse}) => {
    const {BREADCRUMBS_ROOT_LITERAL} = this._config.get('editorial')

    const breadcrumbsLiterals = [BREADCRUMBS_ROOT_LITERAL, detailParams.make, detailParams.model]

    const breadcrumbs = urlsResponse.map((url, index) => {
      return {
        label: breadcrumbsLiterals[index],
        url
      }
    })

    return this._valueObject({breadcrumbs})
  }
}
